/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentEditViewController(this: JS5Object, _: JS5Object, $route: JS5Object, $routeParams: JS5Object,
                                   ContentEditService: JS5Object, BreadcrumbService: JS5Object,
                                   NotificationService: JS5Object, SidebarService: JS5Object, UtilsService: JS5Object) {

    let getData = () => {
        ContentEditService.getEditData().then((editData) => {
            this.contentObject = editData.content;
            this.genres = editData.genres;
            this.networks = editData.networks;
            this.metadataComponentsMap = editData.metadataComponents;
            this.availableLiveFeeds = editData.liveFeeds;
            this.contentLoaded = true;
        });
    };

    BreadcrumbService.editService = ContentEditService;

    this.editService = ContentEditService;
    this.contentObject = {};

    this.currentViewedTab = $routeParams.editView;

    this.searchEnabledTabs = ['collaborators', 'seasons', 'volumes'];

    this.loadingIndicator = {
        backdrop: true,
        show: false,
        title: 'Working',
        message: 'Please wait...'
    };

    let showUnsavedChangesWarning = () => {
        let message = 'You have unsaved changes.  Please save or revert.';
        NotificationService.createWarningNotification(message, '');
    };

    this.permissionViewStates = {
        'Series': {
            preRoll: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
            postRoll: 'SERIES_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRoll: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
            watermark: 'SERIES_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'SERIES_ARTWORK_SEARCH_VIEW_STATE',
        },
        'Movie/Special': {
            preRoll: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
            postRoll: 'MOVIE_POSTROLL_SEARCH_VIEW_STATE',
            breakPrePostRoll: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
            watermark: 'MOVIE_WATERMARK_SEARCH_VIEW_STATE',
            artwork: 'MOVIE_ARTWORK_SEARCH_VIEW_STATE'
        }
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        ContentEditService.contentType = this.contentType;
        SidebarService.editService = ContentEditService;
        ContentEditService.resetBreadcrumbs();

        this.baseUrl = `/meta/${UtilsService.getPathKeywordFromContentType(this.contentType)}`;
        this.brandingConfigGroup = UtilsService.getPathKeywordFromContentType(this.contentType);

        ContentEditService.getViewPermissions(_.get(this, `permissionViewStates.${this.contentType}`)).then((permissions) => {
            this.permissions = permissions;
            getData();
        });
    };

    //================//
    // Event Handlers //
    //================//

    this.isSearchEnabled = () => {
        return _.includes(this.searchEnabledTabs, this.currentViewedTab);
    };

    // TODO: Remove function?
    this.isNextPreviousShown = () => {
        return false;
    };

    this.onTabSelect = (tabName) => {
        $route.updateParams({editView: tabName});
    };

    this.onTabDeselect = (event) => {
        if (ContentEditService.editorForm && ContentEditService.editorForm.$dirty || $routeParams.id === '-1') {
            event.preventDefault();
            showUnsavedChangesWarning();
        }
    };

    let convertBreakPattern = () => {
        ContentEditService.contentObject.breakPrePostRollPattern =
            _.filter(ContentEditService.availableBreakPatterns, (pattern) => {
                if (pattern.id === ContentEditService.contentObject.breakPrePostRollPattern) {
                    return pattern;
                }
            })[0];
    };

    this.onSave = () => {
        this.loadingIndicator.show = true;

        if (typeof this.contentObject.breakPrePostRollPattern === 'object') {
            this.contentObject.breakPrePostRollPattern = this.contentObject.breakPrePostRollPattern.id;
        }

        ContentEditService.saveEditData().then(() => {
            convertBreakPattern();
            this.contentObject = ContentEditService.contentObject;
            this.loadingIndicator.show = false;
        });
    };

    this.onRevert = () => {
        ContentEditService.revertEditData();
        convertBreakPattern();
        this.contentObject = ContentEditService.contentObject;
    };

    this.onClose = () => {
        ContentEditService.exitEdit();
    };
}

angular
    .module('prism-ui.content')
    .component('contentEditView', {
        controller: ContentEditViewController,
        bindings: {
            contentType: '<',
            isSeason: '<'
        },
        templateUrl: 'meta/content/editor/content-edit-view-template.html'
    });
